import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupsIcon from '@mui/icons-material/Groups';
import LaunchIcon from '@mui/icons-material/Launch';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TimelineIcon from '@mui/icons-material/Timeline';
import { Section } from '../../../../../../../corelogic/domain/models/hub.model';

export const guideSections: Section[] = [
  {
    heading: 'Getting Started',
    content:
      "Select a Season and create your team of 8 elite UFC fighters. Pick athletes based on their performance history and upcoming fights to maximize your team's points!",
    sectionIcon: PlayArrowIcon,
  },
  {
    heading: 'Scoring System',
    content: `Fighters earn points through wins, finishes, and performance bonuses. Your team's total score is the sum of all your fighters' points. Click the right arrow to view a detailed breakdown!`,
    icon: LaunchIcon,
    sectionIcon: EmojiEventsIcon,
  },
  {
    heading: 'Team Management',
    content:
      'You can modify your team before each event. On the day of an event, you can no longer swap out fighers that are competing that night - choose wisely!',
    icon: LaunchIcon,
    link: '/teamselector',
    sectionIcon: GroupsIcon,
  },
  {
    heading: 'Season Progress',
    content:
      'Track your performance against other users via our official public tournaments, or through private tournaments. Winners are those with the highest total points.',
    icon: LaunchIcon,
    link: '/tournaments',
    sectionIcon: TimelineIcon,
  },
];
